module.exports = __webpack_public_path__ + "static/media/optRestorative.5df0452d.jpg";